import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api-service.service';



@Component({
    selector: "",
    templateUrl: "./default.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class DefaultComponent implements OnInit {

    public events: any = {};
    countries; pCountry;
    regions = []; pregion: string;
    areas = []; parea: string;
    branches = []; pbranch: string;
    res;

    public dateModel: any = { date: { year: 2018, month: 8, day: 2 } };
    constructor(private Service: ApiService, private _router: Router) { }

    ngOnInit() {
        if ((!!localStorage.getItem('currentUser') == true)) {

        }
        else { this._router.navigate(['/login']) }
    }





}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/main/pages/default/default.component.ts